// 我的档案相关
const Transition = () => import('../pages/transition/index.vue');
export default [
  {
    path: '/transition',
    component: Transition,
    meta: {
      title: '过渡',
    },
  },
];
